// extracted by mini-css-extract-plugin
module.exports = {"btnToast":"toast_btnToast__1uPh-","toast":"toast_toast__1768w","detail":"toast_detail__rmFD1"};